import { createFileRoute } from '@tanstack/react-router';
import { PracticeSection } from '@/features/Lesson/PracticeSection';
import { useTopicDetail } from '@/lib/hooks/useLms';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/practice')({
  component: PracticeRoute,
});

function PracticeRoute() {
  const { batchId, topicId } = Route.useParams();
  const { data: topic } = useTopicDetail(topicId);
  if (!topic) return null;
  return <PracticeSection assessments={topic.assessments} batchId={batchId} topicId={topicId} />;
}
